import {
  ICreateSubordinate,
  IEditSubordinatePermissions,
  IGetSubordinateDetailsPayload,
  IGetSubordinatesParams,
  IGetSubordinatesResponse,
} from '../redux/subordinate/subordinateSlice';
import { backendApiInstance } from './backendApiInstance';

export async function validateOrganisation(data: { organizationName: string; inviteToken: string }): Promise<any> {
  return backendApiInstance.post('/subordinates/validate-organization', data);
}

export async function createSubordinate(data: ICreateSubordinate): Promise<any> {
  return backendApiInstance.post('/subordinates/sign-up', data);
}

export async function getSubordinates(params: IGetSubordinatesParams): Promise<IGetSubordinatesResponse> {
  return backendApiInstance.get('/subordinates/list', { params });
}

export async function getSubordinateDetails({ userId }: IGetSubordinateDetailsPayload): Promise<any> {
  return backendApiInstance.get(`/subordinates/${userId}`);
}
export async function updateSubordinatePermissions(payload: IEditSubordinatePermissions): Promise<any> {
  return backendApiInstance.patch('/subordinates/update-permissions', payload);
}
export async function deleteSubordinate(userId: string): Promise<any> {
  return backendApiInstance.delete(`/subordinates/${userId}`);
}
